export default "__VITE_ASSET__DCYgD6AC__"